import { IUntypedQuery, Topics } from '@zaplify/common';

export interface PPLScrollOptions {
    scroll_id?: string;
    scroll?: string;
}

export class GetPplQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(
        readonly query: any,
        readonly type: '_count' | '_search' | 'clear_scroll',
        readonly integrationToken: string,
        readonly scroll?: PPLScrollOptions,
        readonly routing?: string[],
    ) {
        super();
    }
}
